var ImgSfondo = function($){
    var $this = this;

    $this.init = function(){
        $this.ImgWidth();
        $('#imgSfondo img').load($this.ImgWidth);
        $(window).resize($this.onResize);
    };
    $this.onResize = function(){
        $this.ImgWidth();
    }
    $this.ImgWidth = function(){
        var WinW = $(window).width();
        var WinH = $(window).height();
        var imgHorig = $('#imgSfondo img').height();
        /*console.log(imgHorig);
        console.log(WinH);*/
        $('#imgSfondo').css({'height':WinH});
        if((WinW>WinH) && (imgHorig>=WinH)) {
            $('#imgSfondo img').css({'width':WinW, 'height':'auto'});
            var imgH = $('#imgSfondo img').height();
            var MarTop = Math.abs((WinH-imgH)/2);
            $('#imgSfondo img').css({'margin-top': -MarTop, 'margin-left':'0'});
        } else{
            $('#imgSfondo img').css({'height':WinH, 'width':'auto'});
            var imgW = $('#imgSfondo img').width();
            var MarLeft = Math.abs((WinW-imgW)/2);
            $('#imgSfondo img').css({'margin-left': -MarLeft, 'margin-top': '0'});
        }
    };
};

